import useShowTranslations, {
    translationCSVColumn,
} from 'utils/hooks/useShowTranslations';
import DrawerSectionHeading from 'components/DrawerSectionHeading';
import DefinitionTooltip from 'components/DefinitionTooltip';
import { GoogleIcon } from 'components/Icons';
import TopPhrasesSection from 'components/TopKeywordsSection/TopPhrasesSection';
import { downloadItemsAsCSV } from 'utils/formatCSV';
import { tooltips } from '@/copy';
import useFlavorSearchQueries from './useFlavorSearchQueries';

function SearchQueriesWrapper(props) {
    return <div {...props} />;
}

function SearchQueriesHeading({ children, showIcon }) {
    return (
        <DrawerSectionHeading className="my-6">
            <span css="display: flex; align-items: center; gap: .5rem;">
                {showIcon ? <GoogleIcon /> : null}
                Search Queries
                <DefinitionTooltip
                    {...tooltips.searchQueries}
                    mixpanelMeta={{ contentKey: 'searchQueries' }}
                    openOnClick={true}
                    width="25rem"
                />
            </span>
            {children}
        </DrawerSectionHeading>
    );
}

const defaultCSVColumns = [
    { key: 'kw', label: 'search query' },
    { key: 'volume' },
];

function NoData() {
    return (
        <div
            css={`
                color: ${({ theme }) => theme.neutral_3};
            `}
        >
            No search queries to show.
        </div>
    );
}

function FlavorSearchQueriesDrawer({ country, category, flavor, filename }) {
    const searchQueriesQuery = useFlavorSearchQueries({
        country: country ? [country] : null,
        category: category ? [category] : null,
        flavor: flavor ? [flavor] : null,
        enabled: Boolean(country && category && flavor),
    });
    const sortedData = searchQueriesQuery.data?.data?.map(
        ({ id, search_query, volume, translations }) => ({
            id,
            kw: search_query,
            volume,
            translations: translations || null,
        }),
    );
    const dataReady = !!sortedData?.length;
    const showTranslations = useShowTranslations({
        rows: sortedData,
        countries: [country],
    });
    const handleDownload = () => {
        const columns = showTranslations
            ? [...defaultCSVColumns, translationCSVColumn]
            : defaultCSVColumns;

        downloadItemsAsCSV(filename, sortedData, columns);
    };

    const mixpanelMeta = { contentKey: 'TopKeywords' };

    return (
        <TopPhrasesSection
            data={{ country, category, flavor }}
            isLoading={searchQueriesQuery.isLoading}
            sortedData={sortedData}
            dataReady={dataReady}
            showTranslations={showTranslations}
            handleDownload={handleDownload}
            mixpanelMeta={mixpanelMeta}
            HeadingComponent={SearchQueriesHeading}
            WrapperComponent={SearchQueriesWrapper}
            NoDataComponent={NoData}
        />
    );
}

export default FlavorSearchQueriesDrawer;
